export default __webpack_public_path__ + "static/ebba-7a235c7a97ab51c370119ad4575c72f3.png";